import ProfileOutlinedIcon from '@tenancy.nz/icons/ProfileOutlined';
import CalendarOutlinedIcon from '@tenancy.nz/icons/CalendarOutlined';
import HomeOutlinedIcon from '@tenancy.nz/icons/HomeOutlined';
import ApplicationOutlinedIcon from '@tenancy.nz/icons/ApplicationOutlined';
import AgreementOutlinedIcon from '@tenancy.nz/icons/AgreementOutlined';
import SettingsOutlinedIcon from '@tenancy.nz/icons/SettingsOutlined';

/**
 * Resolves the manifest's icon *names* to web icon components.
 *
 * The shared manifest in @tenant/core carries `icon: 'HomeOutlined'` rather
 * than a component reference, so it stays free of any renderer dependency. The
 * native app keeps its own map against the same names.
 */
const icons = {
  AgreementOutlined: AgreementOutlinedIcon,
  ApplicationOutlined: ApplicationOutlinedIcon,
  CalendarOutlined: CalendarOutlinedIcon,
  HomeOutlined: HomeOutlinedIcon,
  ProfileOutlined: ProfileOutlinedIcon,
  SettingsOutlined: SettingsOutlinedIcon,
};

export default icons;
